import { render, staticRenderFns } from "./LateConsignment.vue?vue&type=template&id=b611cb30&"
import script from "./LateConsignment.vue?vue&type=script&lang=js&"
export * from "./LateConsignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports